import { API_PARTS } from '@constants/api.ts';
import { persistClient } from '@store/services/localStorage.service.ts';

import config from '../../app/config';

export function getClientFromHostOrPath(): string {
    const host = window.location.host;
    const idx = host.indexOf('.');
    if (idx > 0) {
        const client = host.slice(0, idx);
        persistClient(client);

        return client;
    }
    return '';
}

export function buildClientBaseUrl(): string {
    const apiURL = config.apiURL;
    const clientApiName = getClientFromHostOrPath(); // client name from host or path

    if (!clientApiName) {
        return apiURL;
    }

    // Replace first domain segment with clientApiName
    const apiURLFromHost = apiURL.replace(
        /^(https?:\/\/)([^/]+)(?=\/|$)/i,
        (_: string, proto: string, host: string): string => {
            const [hostWithoutPort, port = ''] = host.split(':');
            const parts = hostWithoutPort.split('.');

            if (parts.length > 1) {
                parts[0] = clientApiName;
            } else {
                parts.unshift(clientApiName);
            }

            return `${proto}${parts.join('.')}${port ? `:${port}` : ''}`;
        },
    );

    return `${apiURLFromHost}${API_PARTS.API_VERSION}`;
}
